import { GRAVITY_PRESETS } from "@/lib/tool-kit/physics-mechanics/projectile";
import { parseQuantity } from "@/lib/tool-kit/physics-mechanics/quantity";
import { ACCELERATION, toBase } from "@/lib/tool-kit/physics-mechanics/units";

/** The choice of gravity a calculator offers: a body's surface gravity or a typed value. */
export type GravityPreset = keyof typeof GRAVITY_PRESETS | "custom";

export interface GravityState {
  preset: GravityPreset;
  custom: { value: string; unit: string };
}

export const DEFAULT_GRAVITY: GravityState = {
  preset: "earth",
  custom: { value: "9.8", unit: "mps2" },
};

/** g in m/s², or null when the custom value is blank or unreadable. */
export function readGravity(state: GravityState): number | null {
  if (state.preset !== "custom") {
    return GRAVITY_PRESETS[state.preset];
  }
  const parsed = parseQuantity(state.custom.value);
  return parsed === null
    ? null
    : toBase(parsed, ACCELERATION, state.custom.unit);
}
